import { useTheme } from "@mui/material/styles";


const Styles = () => {
  const theme = useTheme();
  
 
  return {
    area: { 
      margin: '10px',
      marginTop:'80px',
    },
  }
};

export default Styles;
